// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27lightgreen%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27lightgreen%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

:root {
    --font_family: 'Lato', sans-serif;
    --primary_font_size: 1rem;
    --secondary_font_size: 0.938rem;
    --ternary_font_size: 0.875rem;
    --Primary_color: #38CAB3;
    --secondary_color: #4F4F6D;
    --ternary_color: #848498;
    --box_shadow: rgba(170, 170, 170, 0.2) 0px 3px 6px 0px;
    --text_shadow: 3px 0px 6px #818181;
    --border_radius: 0.313rem;
    --input_margin: 1.563rem;
    --border: 0.063rem solid #D9D9D9;
}

a {
    text-decoration: none;
}

body {
    font-family: var(--font_family);
}

h1,
h4,
h5,
h6,
ul {
    margin-bottom: 0;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

input[type=search]::-ms-clear {
    display: none;
    width: 0;
    height: 0;
}

input[type=search]::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
    display: none;
}

/* Scroll Bar css */
/* width */
::-webkit-scrollbar {
    width: 6px;
    height: 5px;
}

::-webkit-scrollbar:vertical {
    width: 0 !important;
}

/* Track */
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px var(--secondary_color);
    border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: var(--Primary_color);
    border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #0fc5aa;
}


.form-switch .form-check-input {
    min-width: 3rem;
    height: 20px;
    border: 1px solid var(--Primary_color);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.form-switch .form-check-input:checked {
    background-color: var(--Primary_color);
}

.form-switch .form-check-input:focus {
    box-shadow: none;
}

.form_switch_wrapper {
    position: relative;
}

.form_switch_wrapper span {
    position: absolute;
    top: 51%;
    transform: translate(-50%, -50%);
    font-size: 6px;
    font-weight: bold;
}

/*=====css for validation message=========*/
.srv-validation-message {
    color: #e23a3a;
    font-size: var(--ternary_font_size);
    margin-top: 3px;
}

.swal2-confirm {
    background-color: var(--Primary_color) !important;
    border: unset !important;
}

.swal2-confirm:focus {
    box-shadow: none !important;
}

.data_not_available_wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--ternary_color);
}

.dashboard_data_not_available {
    text-align: center;
    margin-top: 10rem;
    color: var(--ternary_color);
}

.refresh_icon {
    color: var(--Primary_color);
    cursor: pointer;
}

/* ======css for dashboard layout========== */
.dashboard_wrapper {
    width: 100vw;
    height: 100vh;
    display: flex;
}

.side_nav_section {
    width: 20%;
    height: 100%;
    background-color: #fff;
    box-shadow: var(--box_shadow);
    overflow-x: hidden;
}

.routes_view_section {
    width: 80%;
    height: 100%;
}

.side_nav_wrapper {
    width: 100%;
    height: 100%;
}

.logo {
    height: 15%;
    display: grid;
    place-items: center;
}

.logo h1 {
    color: var(--ternary_color);
    font-weight: bold;
}

.nav_list_wrapper {
    height: 79%;
    overflow-y: auto;
}

.nav_list_wrapper::-webkit-scrollbar {
    width: 0;
}

.logout_box_wrapper {
    height: 6%;
}

.logout_box_wrapper .profile_box_wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    background-color: var(--Primary_color);
    gap: 0.938rem;
    padding-left: 0.625rem;
    position: relative;
    transition: 0.3s ease;
}

.logout_box_wrapper .box_main {
    display: grid;
    place-items: center;
    transition: 0.2s ease-in-out;
}

.logout_box_wrapper .profile_box {
    width: 1.875rem;
    height: 1.875rem;
    border-radius: 50%;
    border: 0.063rem solid var(--Primary_color);
    display: grid;
    place-items: center;
    color: var(--Primary_color);
    cursor: pointer;
}

.logout_box_wrapper .profile {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
}

.profile .profile_title {
    color: #fff;
    font-size: 0.813rem;
}

.logout_box_wrapper .profile_icon {
    width: 1.375rem;
    height: 1.375rem;
    border-radius: 50%;
    background-color: #fff;
    display: grid;
    place-items: center;
}

.profile_icon .svg-inline--fa {
    color: var(--Primary_color);
    font-size: 0.625rem;
}

.profile_box_wrapper .close_button {
    position: absolute;
    top: 50%;
    left: 95%;
    transform: translate(-50%, -50%);
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    background-color: #fff;
    display: grid;
    place-items: center;
    cursor: pointer;
}

.profile_box_wrapper .close_button .svg-inline--fa {
    font-size: 0.75rem;
    color: var(--Primary_color);
}

.tab {
    display: flex;
    align-items: center;
    padding: 0.375rem 0.188rem 0.375rem 1.125rem;
    position: relative;
    cursor: pointer;
    margin-bottom: 0.625rem;
    color: var(--ternary_color);
    font-weight: bold;
}

.tab span,
.dropdown_tab span {
    font-size: var(--primary_font_size);
}

.tab .icon {
    margin-right: 1rem;
}

.tab .icon .svg-inline--fa {
    font-size: 1.125rem;
}

.dropdown_tab {
    padding: 0.375rem 0.188rem 0.375rem 3.325rem;
    cursor: pointer;
    margin-bottom: 0.625rem;
    color: var(--ternary_color);
    font-weight: bold;
    position: relative;
}

.dropdown_tab .sub_dropdown_tab {
    margin-left: 15px;
}

.dropdown_tab ul li {
    list-style-type: none;
    color: var(--ternary_color);
}

.nav_list_wrapper .active .svg-inline--fa {
    color: var(--Primary_color);
}

.nav_list_wrapper .active .tab span,
.nav_list_wrapper .active .dropdown_tab span {
    color: var(--secondary_color);
}

.tab .caret {
    position: absolute;
    top: 50%;
    left: 92%;
    transform: translate(-50%, -50%);
}

.tab .caret .svg-inline--fa {
    transition: 0.3s ease;
}

.nav_list_wrapper .active .tab::after,
.nav_list_wrapper .active .dropdown_tab::after,
.nav_list_wrapper .tab_active::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 1.7%;
    background-color: var(--Primary_color);
    border-top-right-radius: 0.4rem;
    border-bottom-right-radius: 0.4rem;
}

/*=============css for login and reset password page=========*/
.login_wrapper {
    width: 100vw;
    height: 100vh;
    display: grid;
    place-items: center;
}

.login_wrapper .card_wrapper {
    width: 90%;
    height: 85%;
    background-color: #fff;
    overflow: hidden;
    border-radius: var(--border_radius);
    box-shadow: var(--box_shadow);
}

.login_wrapper .card_img {
    width: 100%;
    height: 100%;
}

.login_wrapper .card_img img {
    width: 85%;
    height: 90%;
}

.login_wrapper .form_wrapper {
    height: 100% !important;
    display: grid !important;
    place-items: center;
    overflow-y: auto;
}

.form {
    align-items: center;
    display: grid !important;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
}

.login_wrapper .form_wrapper::-webkit-scrollbar {
    width: 0;
}

.login_wrapper .form_wrapper .form {
    width: 70%;
}

.login_wrapper .title h1 {
    color: var(--Primary_color);
    font-weight: bold;
    font-size: 30px;
}

.login_wrapper .title {
    margin-bottom: 2.188rem;
    text-align: center;
}

.login_wrapper .input_wrapper {
    position: relative;
    margin: var(--input_margin) 0 0 0;
}

.login_wrapper .input_wrapper input {
    border: unset;
    border-bottom: 1px solid var(--Primary_color);
    border-radius: unset;
}

.input_wrapper input:focus {
    box-shadow: none;
}

.login_wrapper .input_wrapper input::placeholder {
    color: var(--Primary_color);
}

.login_wrapper .input_wrapper .svg-inline--fa {
    position: absolute;
    top: 50%;
    left: 95%;
    transform: translate(-50%, -50%);
    color: var(--Primary_color);

}

.login_wrapper .reset {
    text-align: right;
    margin-top: 0.625rem;
}

.login_wrapper .reset a {
    color: var(--Primary_color);
}

.login_wrapper .reset span {
    font-weight: bold;
    cursor: pointer;
}

.login_wrapper .button {
    width: 100%;
    display: grid;
    place-items: center;
    background-color: var(--Primary_color);
    color: #fff;
    padding: 5px 10px;
    border-radius: 1.25rem;
    border: unset;
    font-weight: bold;
    margin-top: var(--input_margin);
}

.backto_login_wrapper {
    margin-top: 15px;
}

.backto_login_wrapper a {
    display: flex;
    justify-content: center;
    align-items: center;
}

.backto_login_wrapper .back_icon {
    /* width: 15px;
    height: 15px; */
    padding: 5px;
    border-radius: 50%;
    background-color: var(--Primary_color);
    border: unset;
    color: #fff;
    display: grid;
    place-items: center;
}

.backto_login_wrapper .back_icon .svg-inline--fa {
    font-size: 12px;
}

.backto_login_wrapper h6 {
    color: var(--Primary_color);
    font-size: var(--ternary_font_size);
    margin-left: 10px;
}

/* ========== Css for Loader========== */
.conatiner_loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: grid;
    place-items: center;
    /* background-color: #38CAB3; */
}

.laoder_wrapper {
    position: absolute;
    /* top: -2.188rem; */
    transform: scale(1.5);
}

.loader {
    height: 1.563rem;
    width: 0.063rem;
    position: absolute;
    animation: rotate 3.5s linear infinite;
}

.loader .dot {
    position: relative;
    top: 1.875rem;
    width: 0.438rem;
    height: 0.438rem;
    background-color: var(--Primary_color);
    border-radius: 50%;
}

.loader_text {
    position: absolute;
    top: 65%;
    font-size: var(--secondary_font_size);
    font-weight: 600;
    font-family: var(--font_family);
    color: var(--Primary_color);
}

@keyframes rotate {
    30% {
        transform: rotate(220deg)
    }

    40% {
        transform: rotate(450deg);
        opacity: 1;
    }

    75% {
        transform: rotate(720deg);
        opacity: 1;
    }

    76% {
        opacity: 0;
    }

    100% {
        opacity: 0;
        transform: rotate(0deg);
    }

}

.loader:nth-child(1) {
    animation-delay: 0.15s;
}

.loader:nth-child(2) {
    animation-delay: 0.3s;
}

.loader:nth-child(3) {
    animation-delay: 0.45s;
}

.loader:nth-child(4) {
    animation-delay: 0.6s;
}

.loader:nth-child(5) {
    animation-delay: 0.75s;
}

.loader:nth-child(6) {
    animation-delay: 0.9s;
}

/* ======== CSS for profile page =============== */
.profile_wrapper {
    width: 100%;
    height: 100%;
    display: grid;
    place-items: center;
}

.profile_wrapper .profile_card {
    width: 90%;
    height: 80%;

    border-radius: var(--border_radius);
    box-shadow: var(--box_shadow);

}

.profile_wrapper .profile_card .profile_header {
    background-color: var(--Primary_color);
    padding: 0.625rem
}

.div_profile1 {
    gap: 1.25rem
}

/* .profile_wrapper .profile_card .profile_body {
    background-color: #fff;
} */

.profile_wrapper .profile_title .profile_icon {
    color: #fff;
    font-size: 0.813rem;
    display: flex;

}

.profile_div {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    color: #fff
}

.profile_wrapper .profile_icon {
    width: 1.375rem;
    height: 1.375rem;
    border-radius: 50%;
    background-color: #fff;
    display: grid;
    place-items: center;


}

.profile_wrapper .profile_icon .svg-inline--fa {
    color: var(--Primary_color);
    font-size: var(--primary_font_size);
}

.profile_body {
    padding: 1.563rem;
}

.profile_wrapper .profile_body .form-control {

    font-size: var(--ternary_font_size) !important;
    font-weight: bold;
    color: var(--secondary_color)
}

.edit_button {
    margin-top: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.profile_wrapper .div_profile2 .profile_icon {
    cursor: pointer;
}

/*========css for top header============*/
.top_header {
    height: 7%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    box-shadow: rgba(197, 197, 197, 0.15) 0px 10px 10px -10px;
    padding: 0.125rem 0.875rem;
}

.top_header .title {
    position: relative;
    padding-left: 0.625rem;
    color: var(--secondary_color);
    font-weight: bold;
    font-size: var(--primary_font_size);
}

.top_header .title::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 0.188rem;
    background-color: var(--Primary_color);
}

.top_header .search_wrapper {
    position: relative;
    box-shadow: rgba(164, 164, 164, 0.1) 0 0 1rem;
    cursor: pointer;
    overflow: hidden;
}

.top_header .search_wrapper input {
    height: 2.313rem;
    border: 0.063rem solid var(--Primary_color);
    transition: 0.1s ease-in-out;
}

.top_header .search_wrapper input:focus {
    box-shadow: none;
}

.top_header .search_wrapper .svg-inline--fa {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    color: var(--Primary_color);
}

.top_header .search_wrapper input::placeholder {
    margin-left: 20px;
}

/*===========css for pagination=============*/
.paginationWrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}

.paginationInputWrapper {
    display: flex;
    align-items: center;
    position: relative;
    width: 32%;
    height: 30px;
    border: 1px solid var(--Primary_color);
    border-radius: 3px;
}

.paginationInputWrapper .form-control {
    border: unset;
    height: 100%;

}


.paginationWrapper .btn_pagination {
    color: var(--Primary_color);
    padding: 2px 8px;
    border-radius: 3px;
    border: 1px solid var(--Primary_color);
    background-color: #fff;
}

.paginationWrapper .btn_pagination:disabled {
    background-color: rgb(235, 235, 235);
    cursor: not-allowed
}

.paginationInputWrapper .find_btn {
    border: unset;
    background-color: var(--Primary_color);
    padding: 0px 10px;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    color: #fff;

}

.paginationWrapper .paginationInputWrapper h6 {
    color: var(--Primary_color);
}


.paginationInputWrapper .form-control:focus {
    border-color: inherit;
    box-shadow: none;
}

.paginationInputWrapper .find_btn:hover {
    background-color: var(--Primary_color);
    color: #fff
}

/* old pagination */
.pagination_wrapper .pagination li {
    width: 21px;
    height: 21px;
    border-radius: 50%;
    background-color: #fff;
    color: var(--ternary_color);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    box-shadow: var(--box_shadow);
}

.pagination_wrapper .pagination li a {
    font-size: 10px;
}

.pagination_wrapper .pagination .active {
    color: #fff;
    background-color: var(--Primary_color);
}

.pagination_wrapper .pagination .previous,
.pagination_wrapper .pagination .next {
    width: unset !important;
    border-radius: 0 !important;
    background-color: unset !important;
    box-shadow: none;
}

.pagination_wrapper .pagination .previous a,
.pagination_wrapper .pagination .next a {
    color: var(--Primary_color) !important;
    cursor: pointer;
    font-weight: bold;
}

/*============css for table============*/
.routes_view_section section {
    height: 93%;
    background-color: #F7F9FA;
    padding: 0.875rem;
    position: relative;
}

.routes_view_section .section_wrapper {
    width: 100%;
    height: 100%;
    background-color: #fff;
    box-shadow: rgba(164, 164, 164, 0.1) 0 0 1rem;
    border-radius: var(--border_radius);
    padding: 1% 1% 0 1%;
}

.section_header_wrapper {
    width: 100%;
    height: 8%;
    /* background-color: #848498; */
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.survey_management_header {
    height: 13%;
    align-items: center;
}

.button_wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}

.button,
.filter_button {
    border: 1px solid var(--Primary_color);
    font-size: var(--ternary_font_size);
    padding: 2px 15px;
    color: var(--Primary_color);
    background-color: #fff;
    border-radius: 15px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: 0.3s ease-in;
}

.button:hover {
    background-color: var(--Primary_color);
    color: #fff;
}

.filter_button {
    color: #fff;
    background-color: var(--Primary_color);
}

.filter_button:hover {
    background-color: #fff;
    color: var(--Primary_color);
}

.table_wrapper {
    width: 100%;
    height: 92%;
    overflow: auto;
    position: relative;
}

.table_wrapper .table {
    margin-bottom: 0;
}

.election_table,
.survey_data_wrapper .table {
    min-width: 1100px;
}

.organization_table {
    min-width: 1600px;
}

.voter_table {
    min-width: 1700px;
}

.survey_data_wrapper {
    height: 87%;
}

.survey_trends_wrapper .table,
.voter_list_wrapper .table {
    min-width: 1300px;
}

.onField_input_table_wrapper {
    height: 77%;
}

.onField_input_table_wrapper .table,
.activity_table_wrapper .table {
    min-width: 1350px;
}

.table_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #F7F9FA;
    border: 1px solid #EDEDF5;
    border-left: none;
    border-right: none;
    position: sticky;
    top: 0;
    z-index: 1;
}

.table_header .row,
.table_data .row {
    width: 100%;
}

.table_header h5 {
    font-size: var(--ternary_font_size);
    font-weight: 600;
    color: var(--ternary_color);
    text-align: center;
}

.table_data {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #EDEDF5;
}

.table_data h6 {
    font-size: var(--ternary_font_size);
    color: var(--ternary_color);
    text-align: center;
    text-transform: capitalize;
}

.survey_trends_wrapper .table_data h6 {
    color: #fff;
}

.table_data .voterId h6 {
    text-transform: unset;
}

.serial_number,
.gender {
    width: 8%;
}

.election_name,
.booth_name,
.full_name,
.event_name,
.description {
    width: 20%;
}

.name,
.election_type,
.password,
.designation,
.alloted_member {
    width: 15%;
}

.party,
.city,
.voterId {
    width: 15%;
}

.election_year,
.polling_name,
.page_number,
.mobile_number,
.booth_name {
    width: 13%;
}

.date,
.userId,
.survey_name,
.points {
    width: 13%;
}

.action,
.gender,
.election_action {
    min-width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
}

.election_action {
    width: 15%;
}

.row_action {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
}

.action .action_button,
.election_action .action_button {
    font-size: 12px;
    padding: 1px 8px;
    border-radius: 15px;
    background-color: var(--Primary_color);
    border: 1px solid var(--Primary_color);
    color: #fff;
}

.action .svg-inline--fa,
.row_action .svg-inline--fa,
.election_action .svg-inline--fa {
    color: var(--Primary_color);
    cursor: pointer;
}

.password {
    position: relative;
}

.password .svg-inline--fa {
    position: absolute;
    top: 50%;
    right: 0%;
    transform: translate(-50%, -50%);
    padding: 0;
    color: var(--ternary_color);
    font-size: 14px;
}

.table_data .password h5 {
    font-size: 24px;
    margin-top: -15px;
    color: var(--ternary_color);
}

.password h6 {
    text-align: left;

}


.vote {
    width: 25%;
    text-align: center;
    overflow: hidden;
}

/*==========css for modal===========*/
.modal_wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #bababa4a;
    display: grid;
    place-items: center;
    z-index: 1;
}

.form_wrapper_main {
    width: 100%;
    height: 100%;
    background-color: #F7F9FA;
    display: grid;
    place-items: center;
}

.modal_wrapper .card_wrapper,
.form_wrapper_main .card_wrapper {
    width: 60%;
    max-height: 95%;
    overflow-y: auto;
    background-color: #fff;
    border-radius: var(--border_radius);
    border: var(--border);
    box-shadow: var(--box_shadow);
}

.form_wrapper_main .card_wrapper {
    width: 90%;
}

.modal_wrapper .card_header,
.form_wrapper_main .card_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 15px;
    border-bottom: var(--border);
    position: sticky;
    top: 0;
    background-color: #fff;
}

.modal_wrapper .card_header .title,
.form_wrapper_main .card_header .title {
    position: relative;
    padding-left: 10px;
}

.modal_wrapper .card_header .title h5,
.form_wrapper_main .card_header .title h5 {
    font-size: var(--secondary_font_size);
    color: var(--secondary_color);
    font-weight: 600;
}

.modal_wrapper .card_header .title::after,
.form_wrapper_main .card_header .title::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    background-color: var(--Primary_color);
}

.modal_wrapper .card_header .close_button,
.form_wrapper_main .card_header .close_button {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid var(--Primary_color);
    display: grid;
    place-items: center;
    color: var(--Primary_color);
    cursor: pointer;
}

.modal_wrapper .card_body,
.form_wrapper_main .card_body {
    padding: 15px;
}

.input_box_wrapper {
    margin-bottom: 10px;
}

.input_box_wrapper label {
    font-size: var(--ternary_font_size);
    color: var(--secondary_color);
    font-weight: 600;
    margin-bottom: 5px;
}

.input_box_wrapper input,
.input_box_wrapper select,
.input_box_wrapper textarea,
.react-datepicker-wrapper input {
    border: var(--border);
    box-shadow: var(--box_shadow);
    line-height: 1.4;
    font-size: var(--ternary_font_size);
    color: var(--ternary_color) !important;
}

.multiSelectContainer {
    border: unset;
}

.multiSelectContainer .searchWrapper {
    position: relative;
    min-height: 32.93px;
    padding: 0;
    overflow: hidden;
    box-shadow: var(--box_shadow);
}

.multiSelectContainer .searchWrapper input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0.375rem 0.75rem;
    border-radius: var(--border_radius);
    margin-top: 0;
}

.multiSelectContainer .searchWrapper .svg-inline--fa {
    font-size: 14px;
}

.multiSelectContainer .searchWrapper input:focus {
    border: unset;
}

.icon_down_dir {
    right: 12px;
}

.icon_down_dir:before {
    display: none;
}

.chip img {
    display: none;
}

.input_box_wrapper input::placeholder,
.input_box_wrapper textarea::placeholder,
.react-datepicker-wrapper input::placeholder {
    color: var(--ternary_color);
}

.input_box_wrapper input:focus,
.input_box_wrapper select:focus,
.input_box_wrapper textarea:focus,
.react-datepicker-wrapper input:focus {
    box-shadow: none;
    border: var(--border);
}

.react-datepicker-wrapper input {
    width: 100%;
    border-radius: var(--border_radius);
    padding: 0.375rem 0.75rem;
}

.react-datepicker-ignore-onclickoutside:focus {
    outline: none;
}

.input_box_wrapper .party_select_box,
.input_box_wrapper .designation_select_box {
    text-transform: capitalize;
}

.modal_wrapper .submit_button_wrapper,
.form_wrapper_main .submit_button_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal_wrapper .submit_button_wrapper .filter_button,
.form_wrapper_main .submit_button_wrapper .filter_button {
    padding: 3px 25px;
    font-weight: 600;
    margin-top: 10px;
}

.form-select_data {
    width: 0;
    float: right;
}

.button_wrapper select {
    line-height: 1.4;
    font-size: var(--ternary_font_size);
    border: 1px solid var(--Primary_color);
    color: var(--Primary_color);
    border-radius: 20px;
    padding: 3px 30px 3px 10px;
}

.button_wrapper select:focus {
    box-shadow: none;
}

.import_data_wrapper {
    width: 60%;
    margin: auto;
}

.import_data_wrapper label {
    width: 100%;
    border: 1px solid var(--Primary_color);
    padding: 3% 2%;
    box-shadow: var(--box_shadow);
    border-radius: var(--border_radius);
    text-align: center;
    color: var(--Primary_color);
    overflow: hidden;
    margin-bottom: 15px;
    cursor: pointer;
}

.import_data_wrapper .svg-inline--fa {
    font-size: 24px;
    margin-bottom: 15px;
}

.import_data_wrapper span {
    color: var(--ternary_color);
}

/* ========== Designation CSS ============== */


.designation_wrapper {
    width: 100%;
    height: 100%;
    background-color: #F7F9FA;
    display: grid;
    place-items: center;
}


.designation_wrapper .designation_card {
    width: 90%;
    height: 90%;
    overflow-y: auto;
    background-color: #fff;
    border-radius: var(--border_radius);
    border: var(--border);
    box-shadow: var(--box_shadow);

}

.designation_wrapper .card_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 15px;
    border-bottom: var(--border);
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #fff;
}

.designation_wrapper .card_header .title {
    position: relative;
    padding-left: 10px;
}

.designation_wrapper .card_header .title h5 {
    font-size: var(--ternary_font_size);
    color: var(--secondary_color);
    font-weight: 600;
}

.designation_wrapper .designation_card .card_header .close_button {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid var(--Primary_color);
    display: grid;
    place-items: center;
    color: var(--Primary_color);
    cursor: pointer;
}

.designation_wrapper .card_body {
    padding: 1.563rem;
}

.designation_wrapper .designation_tab_heading h6 {
    font-size: var(--secondary_font_size);
    color: var(--Primary_color);
    font-weight: bold;

}

.designation_wrapper .check_box_wrapper {
    display: flex;
    align-items: center;
    gap: 20px;
}

.check_box_wrapper label {
    font-size: var(--ternary_font_size);
    color: var(--secondary_color);
    font-weight: 600;
    margin-bottom: 5px;
}

.designation_card .card_header .close_button {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid var(--Primary_color);
    display: grid;
    place-items: center;
    color: var(--Primary_color);
    cursor: pointer;
}

.action_designation .svg-inline--fa {
    color: var(--Primary_color);
    cursor: pointer;
}

.booth_access_wrapper {
    position: relative;
}

.booth_access_wrapper .add_access_button {
    position: absolute;
    top: 50%;
    right: 5%;
    transform: translate(-50%, -20%);
    border: var(--border);
    box-shadow: var(--box_shadow);
    color: var(--ternary_color) !important;
    padding: 3px 10px;
    border-radius: var(--border_radius);
    background-color: var(--Primary_color);
    color: #fff !important;
}

.booth_access_wrapper .trash_button {
    position: absolute;
    top: 40%;
    right: 15%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    color: #e23a3a;
}

.gender_input_wrapper {
    display: flex;
    gap: 15px;
}

/*=====survey management css========*/
.vote .party_wrapper {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 10px;
}

.gender_input input {
    color: var(--Primary_color);
    margin-top: 0;
}

.gender_input label {
    font-size: var(--ternary_font_size);
    color: var(--ternary_color);
    margin-left: 8px;
    font-weight: normal;
    margin-bottom: 0;
}

.gender_input {
    display: flex;
    align-items: center;
}

.vote .party_wrapper .party_input {
    width: calc(100% / 3);
}

.vote .party_wrapper input {
    margin-top: 0.35rem;
    border: 1px solid var(--Primary_color);
}

.vote .party_wrapper .form-check-input:checked {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-color: unset !important;
    box-shadow: unset;
}

.vote .party_wrapper label {
    margin-left: 5px;
    color: var(--ternary_color);
    font-size: var(--ternary_font_size);
}

.survey_data_wrapper .link a {
    border-bottom: 1px solid var(--ternary_color);
    cursor: pointer;
}

.survey_card_wrapper,
.data_analysis_card_wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
}

.survey_card_wrapper .survey_card,
.data_analysis_card_wrapper .survey_card {
    min-width: 150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    padding: 5px 10px;
    border-radius: var(--border_radius);
    background-image: linear-gradient(to right, #40DA9C, #3CC0AD);
}

.data_analysis_card_wrapper {
    margin: 15px 0;
    gap: 20px;
}

.data_analysis_card_wrapper .survey_card {
    min-width: 25%;
}

.survey_card_wrapper .survey_card:nth-child(2),
.data_analysis_card_wrapper .survey_card:nth-child(2) {
    background-image: linear-gradient(to right, #FFC944, #FF9F50);
}

.survey_card_wrapper .survey_card h6,
.data_analysis_card_wrapper .survey_card h6 {
    font-size: 12px;
    color: #fff;
    text-shadow: var(--text_shadow);
}

.data_analysis_card_wrapper .survey_card h6 {
    font-size: var(--primary_font_size);
    font-weight: 600;
}

.survey_card .icon_wrapper {
    text-align: center;
}

.survey_card .icon_wrapper .svg-inline--fa {
    color: var(--Primary_color);
    color: #fff;
    text-shadow: var(--text_shadow);
}

.data_analysis_card_wrapper .survey_card .icon_wrapper .svg-inline--fa {
    font-size: 24px;
    margin-bottom: 7px;
}

.input_box_wrapper .checkbox_wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
}

.checkbox_wrapper .form-check-input {
    margin-top: 0;
    border: 1px solid var(--Primary_color);
}

.checkbox_wrapper h6 {
    font-size: var(--ternary_font_size);
    color: var(--ternary_color);
}

.aid_card_wrapper {
    width: 80% !important;
}

/*==========css for Data Analysis===========*/
.survey_analysis_tab_wrapper {
    display: flex;
    align-items: center;
}

.survey_analysis_tab_wrapper .tab {
    min-width: 10%;
    padding: 5px 10px;
    border: 1px solid var(--Primary_color);
    display: flex;
    justify-content: center;
    align-items: center;
}

.survey_analysis_tab_wrapper .tab h5 {
    font-size: var(--primary_font_size);
    font-weight: 600;
    color: var(--Primary_color);
}

.survey_analysis_tab_wrapper .active {
    background-color: var(--Primary_color);
}

.survey_analysis_tab_wrapper .active h5 {
    color: #fff;
}

.survey_analysis_graph_wrapper {
    width: 100%;
    height: 60vh;
    overflow-x: auto;
}

.survey_analysis_graph_wrapper .graph_main {
    width: 100%;
    overflow-x: auto;
}

.survey_analysis_graph_wrapper::-webkit-scrollbar {
    width: 0 !important;
}

.survey_analysis_graph_wrapper canvas {
    max-height: 350px;
}

/*==========css for Voting Day Tab===============*/
.counter_card_wrapper {
    width: 100%;
    height: 15%;
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 0 0 15px 0;
}

.counter_card_wrapper .counter_card {
    width: calc(100% / 6);
    text-align: center;
    padding: 5px;
    border-radius: var(--border_radius);
    background-image: linear-gradient(to right, #21D1D6, #4994E2);
    color: #fff;
}

.counter_card_wrapper .counter_card h5 {
    font-size: var(--secondary_font_size);
    margin-bottom: 5px;
    font-weight: 600;
    text-shadow: var(--text_shadow);
}

.counter_card_wrapper .counter_card h6 {
    font-size: var(--ternary_font_size);
    font-weight: 600;
    text-shadow: var(--text_shadow);
}

.counter_card_wrapper .counter_card:nth-child(2) {
    background-image: linear-gradient(to right, #3FD899, #3CBEAE);
}

.counter_card_wrapper .counter_card:nth-child(3) {
    background-image: linear-gradient(to right, #C087F7, #9342D0);
}

.counter_card_wrapper .counter_card:nth-child(4) {
    background-image: linear-gradient(to right, #F06A7C, #F95E91);
}

.counter_card_wrapper .counter_card:nth-child(5) {
    background-image: linear-gradient(to right, #FFCB43, #FF9852);
}

.msi_panel_wrapper {
    height: 100%;
}

.msi_panel_wrapper .col-lg-6 {
    height: 50%;
}

.msi_panel_wrapper .col-lg-6:nth-child(2) .msi_panel_card_wrapper {
    overflow-y: auto;
}

.msi_panel_wrapper .col-lg-6:nth-child(2) .msi_panel_card_wrapper::-webkit-scrollbar {
    height: 0;
}

.msi_panel_card_wrapper,
.dashboard_graph_card_wrapper {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: var(--border_radius);
    padding: 8px;
}

.msi_panel_card_wrapper .booth_card_wrapper {
    width: 100%;
    display: flex;
    gap: 15px;
}

.booth_card_wrapper .booth_card {
    width: calc(100% / 2);
}

.booth_card_wrapper .booth_card .title h5 {
    font-size: var(--ternary_font_size);
    color: #FFC446;
    font-weight: 600;
    text-shadow: 3px 0px 6px #d3d2d2;
    text-align: left;
}

.booth_card_wrapper .booth_table {
    text-align: center;
    margin-top: 10px;
}

.booth_table .header,
.booth_table .data {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 8px 3px;
}

.booth_table .data {
    border-bottom: 1.2px solid rgb(234, 233, 233);
}

.booth_table .header h6 {
    color: #fff !important;
    text-shadow: var(--text_shadow);
}

.booth_card_wrapper .booth_table h6 {
    font-size: 13px;
    color: var(--ternary_color);
}

.booth_table .data .column a {
    border-bottom: 1px solid grey;
    cursor: pointer;
}

.booth_table .column {
    width: calc(100% / 3);
}

.booth_card_wrapper .booth_card:nth-child(1) .header {
    background-image: linear-gradient(to right, #FFC944, #FFA150);
}

.booth_card_wrapper .booth_card:nth-child(2) .header {
    background-image: linear-gradient(to right, #40DA9C, #3CC3AA);
}

.booth_card_wrapper .booth_card:nth-child(2) .title h5 {
    color: var(--Primary_color);
}

/* =============BenificialVote ==============*/
.beneficial_voters_count {
    min-width: 230px;
    border: 1px solid var(--Primary_color);
    padding: 3px 15px;
    color: var(--Primary_color);
    background-color: #fff;
    border-radius: 15px;
    line-height: 1.4;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    font-size: var(--ternary_font_size);
}

.beneficial_voters_count h6 {
    font-size: var(--ternary_font_size);
}

.msi_panel_card_wrapper .title h5,
.dashboard_graph_card_wrapper .title h5 {
    text-align: center;
    font-size: var(--secondary_font_size);
    font-weight: 600;
    color: var(--secondary_color);
}

.booth_report_graph_wrapper {
    width: 100%;
    height: 100%;
    overflow-x: auto;
}

.booth_report_graph_wrapper .booth_report_graph {
    width: auto;
    overflow-x: auto;
}

.booth_report_graph_wrapper::-webkit-scrollbar {
    width: 0 !important;
}

.booth_report_graph_wrapper canvas {
    max-height: 210px;
}

.final_report_graph_wrapper {
    width: 100%;
    height: 100%;
}

.final_report_graph {
    height: 100%;
    overflow-y: auto;
    display: grid;
    place-items: center;
}

.final_report_graph canvas {
    width: 180px !important;
    height: 180px !important;
}

.final_report_label_wrapper {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 10px;
}

.final_report_label_wrapper .label_wrapper,
.voting_area_label_wrapper .voting_area_label {
    display: flex;
    align-items: center;
    gap: 10px;
}

.voting_area_label_wrapper .voting_area_label {
    margin-bottom: 10px;
}

.final_report_label_wrapper .label_wrapper h6,
.voting_area_label_wrapper .voting_area_label h6 {
    color: var(--ternary_color);
    font-size: 12px;
}

.final_report_label_wrapper .label_wrapper .label_color_box,
.voting_area_label_wrapper .label_color_box {
    width: 40px;
    height: 12px;
}

.final_report_label_wrapper .label_wrapper:nth-child(1) .label_color_box {
    background-color: #3BCD90;
}

.final_report_label_wrapper .label_wrapper:nth-child(2) .label_color_box {
    background-color: #25D2DC;
}

.final_report_label_wrapper .label_wrapper:nth-child(3) .label_color_box {
    background-color: #FA6D83;
}

.hyperlink a {
    border-bottom: 1px solid var(--ternary_color);
    cursor: pointer;
    margin-bottom: 8px;
}

/*======css for voting area graph=====*/
.voting_area_label_wrapper .voting_area_label:nth-child(1) .label_color_box {
    background-color: var(--Primary_color);
}

.voting_area_label_wrapper .voting_area_label:nth-child(2) .label_color_box {
    background-color: #6DE8D4;
}

.voting_area_label_wrapper .voting_area_label:nth-child(3) .label_color_box {
    background-color: #FF7D7D;
}

.voting_area_graph_wrapper {
    width: 100%;
    height: 100%;
    /* overflow-y: auto; */
}

.voting_area_graph_wrapper::-webkit-scrollbar {
    width: 0;
}

/*=================================*/
.voting_area_graph_wrapper {
    position: relative;
    height: 100%;
}

.voting_area_graph_wrapper .svg_wrapper {
    position: absolute;
    width: 100px;
    height: 80px;
    overflow: hidden;
}

.voting_area_graph_wrapper .svg_wrapper svg {
    width: 100%;
    height: 100%;
}

.voting_area_graph_wrapper .svg_wrapper svg path {
    stroke: grey;
    stroke-width: 20;
}

.voting_area_graph_wrapper .svg_wrapper h6 {
    position: absolute;
    top: 50%;
    left: 45%;
    transform: translate(-50%, -50%);
    font-size: 12px;
    text-align: center;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(1) {
    top: 30%;
    left: 7%;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(2) {
    top: -10%;
    left: 30%;
    width: 130px;
    height: 110px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(3) {
    top: 66.3%;
    right: 8.5%;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(4) {
    top: 70%;
    left: -19%;
    width: 150px;
    height: 130px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(5) {
    top: 97%;
    left: 15%;
    width: 80px;
    height: 75px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(5) h6 {
    font-size: 11px;
    transform: translate(-50%, -50%) rotate(45deg);
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(6) {
    top: 86%;
    left: 30%;
    width: 80px;
    height: 50px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(7) {
    top: 143.5%;
    left: -11.4%;
    width: 129px;
    height: 130px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(8) {
    top: 180%;
    left: 7%;
    width: 190px;
    height: 90px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(8) h6 {
    top: 40%;
    transform: translate(-20%, -50%) rotate(45deg);
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(9) {
    top: 113%;
    left: 40%;
    width: 104px;
    height: 100px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(10) {
    top: 95%;
    right: 0%;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(10) h6 {
    top: 70%;
    left: 55%;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(11) {
    top: 120%;
    left: -20%;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(12) {
    top: 180%;
    right: 23%;
    width: 107px;
    height: 90px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(12) h6 {
    transform: translate(-50%, -50%) rotate(-45deg);
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(13) {
    top: 182%;
    right: 5%;
    width: 80px;
    height: 60px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(14) {
    top: 285%;
    left: -7%;
    width: 120px;
    height: 95px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(14) h6 {
    top: 35%;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(15) {
    top: 264.5%;
    left: 25.9%;
    width: 115px;
    height: 88px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(15) h6 {
    top: 40%;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(16) {
    top: 225%;
    right: 13.5%;
    width: 90px;
    height: 78px;
}

.voting_area_graph_wrapper .svg_wrapper:nth-child(16) h6 {
    left: 55%;
}

/*==================css for Activity management tab===================*/
.event_button_wrapper {
    height: 100%;
    position: relative;
}

.event_button_wrapper button {
    position: absolute;
    bottom: 13px;
    border: var(--border);
    padding: 2px 8px;
    background-color: #fff;
    border-radius: var(--border_radius);
}

.event_button_wrapper button .trash {
    color: #e23a3a;
}

/*=================css for Download Template============*/
.download_template_wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
}

.download_template_wrapper .card_wrapper {
    position: relative;
    min-width: 300px;
    text-align: center;
    border-radius: var(--border_radius);
    background-color: var(--Primary_color);
    padding: 1% 2%;
    overflow: hidden;
    cursor: pointer;
}

.download_template_wrapper .card_wrapper::before {
    position: absolute;
    content: "";
    left: -10%;
    bottom: -6%;
    width: 30%;
    height: 40%;
    background-color: #fff;
    transform: rotate(45deg);
}

.download_template_wrapper .card_wrapper h6 {
    color: #fff;
    text-shadow: var(--text_shadow);
    font-size: var(--ternary_font_size);
    font-weight: 600;
}

.download_template_wrapper .card_wrapper .svg-inline--fa {
    color: #fff;
    box-shadow: var(--box_shadow);
}

.download_template_wrapper .card_wrapper:nth-child(1) h6,
.download_template_wrapper .card_wrapper:nth-child(2) h6 {
    margin: 5px 0;
}

.download_template_wrapper .card_wrapper:nth-child(1) {
    background-image: linear-gradient(to right, #40DA9C, #3CC0AD);
}

.download_template_wrapper .card_wrapper:nth-child(2) {
    background-image: linear-gradient(to right, #FFC944, #FF9F50);
}

.download_template_wrapper .card_wrapper .download_icon {
    position: absolute;
    left: 3%;
    bottom: 7%;
    box-shadow: unset;
}

.download_template_wrapper .card_wrapper:nth-child(1) .download_icon {
    color: var(--Primary_color);
}

.download_template_wrapper .card_wrapper:nth-child(2) .download_icon {
    color: #FFC944;
}

/*==================css for Dashboard=================*/
.current_progress_wrapper {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}

.dashboard_graph_wrapper {
    width: 100%;
    height: 100%;
    overflow-x: auto;
}

.dashboard_graph_wrapper canvas {
    max-height: 500px !important;
}

.immediate_focus_graph canvas {
    cursor: pointer;
}

.dashboard_card_wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 5.5%;
}

.dashboard_card_wrapper .card_wrapper {
    position: relative;
    box-shadow: var(--box_shadow);
    width: calc(100% / 5);
    height: 150px;
    padding: 10px;
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;
}

.dashboard_card_wrapper .card_wrapper .inner_card {
    margin: auto;
    width: 95%;
    height: 95%;
    display: grid;
    place-items: center;
    text-align: center;
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 20px 40px -12px inset, rgba(179, 179, 179, 0.3) 0px 18px 36px -18px inset;
    padding: 2%;
}

.dashboard_card_wrapper .card_wrapper .count {
    position: absolute;
    left: 0;
    bottom: 0;
    min-width: 70%;
    height: 20%;
    background-color: #fff;
    display: grid;
    place-items: center;
}

.dashboard_card_wrapper .card_wrapper .count h6 {
    color: var(--ternary_color);
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 1px;
}

.dashboard_card_wrapper .card_wrapper .inner_card .svg-inline--fa {
    font-size: 22px;
    color: #fff;
    box-shadow: var(--box_shadow);
    margin-bottom: 8px;
}

.dashboard_card_wrapper .card_wrapper .inner_card h6 {
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    text-shadow: var(--text_shadow);
}

.dashboard_card_wrapper .card_wrapper:nth-child(1) .inner_card {
    background-image: linear-gradient(to bottom, #20D9DB, #5487E7);
}

.dashboard_card_wrapper .card_wrapper:nth-child(2) .inner_card {
    background-image: linear-gradient(to bottom, #F85A94, #FA7081);
}

.dashboard_card_wrapper .card_wrapper:nth-child(3) .inner_card {
    background-image: linear-gradient(to bottom, #40DC9A, #3CB9B2);
}

.dashboard_card_wrapper .card_wrapper:nth-child(4) .inner_card {
    background-image: linear-gradient(to bottom, #FFD042, #FF8A56);
}

.dashboard_card_wrapper .card_wrapper:nth-child(5) .inner_card {
    background-image: linear-gradient(to bottom, #C48DFA, #8831C6);
}

.dashboard_card_wrapper .card_wrapper:nth-child(1) .count {
    border-bottom: 1.5px solid #29CADD;
}

.dashboard_card_wrapper .card_wrapper:nth-child(2) .count {
    border-bottom: 1.5px solid #FA6A86;
}

.dashboard_card_wrapper .card_wrapper:nth-child(3) .count {
    border-bottom: 1.5px solid #3FD69E;
}

.dashboard_card_wrapper .card_wrapper:nth-child(4) .count {
    border-bottom: 1.5px solid #FFC545;
}

.dashboard_card_wrapper .card_wrapper:nth-child(5) .count {
    border-bottom: 1.5px solid #B475EC;
}


.current_progress_wrapper .dashboard_graph_card_wrapper {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    box-shadow: var(--box_shadow);
    border-radius: var(--border_radius);
}

.current_progress_wrapper .main_card_column {
    height: 70%;
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,+BAA+B;IAC/B,6BAA6B;IAC7B,wBAAwB;IACxB,0BAA0B;IAC1B,wBAAwB;IACxB,sDAAsD;IACtD,kCAAkC;IAClC,yBAAyB;IACzB,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;;;;IAKI,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA,YAAY;AACZ;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,SAAS;AACb;;AAEA;;;;IAII,aAAa;AACjB;;AAEA,mBAAmB;AACnB,UAAU;AACV;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA,UAAU;AACV;IACI,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,yDAA2J;AAC/J;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,cAAc;IACd,iBAAiB;AACrB;;AAEA,2CAA2C;AAC3C;IACI,cAAc;IACd,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,6CAA6C;AAC7C;IACI,YAAY;IACZ,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,4CAA4C;IAC5C,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf,uBAAuB;IACvB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,sCAAsC;IACtC,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA,8DAA8D;AAC9D;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,2BAA2B;;AAE/B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;mBACe;IACf,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,iBAAiB;AACrB;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,qCAAqC;IACrC,gBAAgB;IAChB,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,yBAAyB;QACzB,UAAU;IACd;;IAEA;QACI,yBAAyB;QACzB,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,uBAAuB;IAC3B;;AAEJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,kDAAkD;AAClD;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;;IAEX,mCAAmC;IACnC,6BAA6B;;AAEjC;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;;;AAGvB;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,8CAA8C;IAC9C,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA,yCAAyC;AACzC;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,yDAAyD;IACzD,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;IAC7B,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,6CAA6C;IAC7C,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,2CAA2C;IAC3C,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,6CAA6C;AAC7C;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;;AAEhB;;;AAGA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,WAAW;;AAEf;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,qBAAqB;IAErB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,sCAAsC;AAC1C;;AAEA;;IAEI,uBAAuB;IACvB,2BAA2B;IAC3B,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;;IAEI,sCAAsC;IACtC,eAAe;IACf,iBAAiB;AACrB;;AAEA,wCAAwC;AACxC;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,6CAA6C;IAC7C,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,+BAA+B;IAC/B,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,sCAAsC;IACtC,mCAAmC;IACnC,iBAAiB;IACjB,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,wBAAwB;AAC5B;;AAEA;IACI,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,SAAS;AACb;;AAEA;;;;;IAKI,UAAU;AACd;;AAEA;;;;;IAKI,UAAU;AACd;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;;;IAKI,UAAU;AACd;;AAEA;;;;IAII,UAAU;AACd;;AAEA;;;IAGI,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;IACtC,sCAAsC;IACtC,WAAW;AACf;;AAEA;;;IAGI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;;AAEpB;;;AAGA;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,mCAAmC;IACnC,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,MAAM;IACN,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,qCAAqC;IACrC,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;;;IAII,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mCAAmC;IACnC,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;IAGI,2BAA2B;AAC/B;;AAEA;;;;IAII,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,sCAAsC;IACtC,2BAA2B;IAC3B,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,cAAc;IACd,6BAA6B;IAC7B,mCAAmC;IACnC,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,8CAA8C;;;AAG9C;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;;AAGA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,mCAAmC;IACnC,qBAAqB;IACrB,6BAA6B;;AAEjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mCAAmC;IACnC,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,qBAAqB;IACrB,6BAA6B;IAC7B,sCAAsC;IACtC,iBAAiB;IACjB,mCAAmC;IACnC,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gCAAgC;IAChC,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,yDAA2J;IAC3J,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,mCAAmC;AACvC;;AAEA;IACI,6CAA6C;IAC7C,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,mCAAmC;IACnC,6DAA6D;AACjE;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,6DAA6D;AACjE;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,6CAA6C;AAC7C;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,kDAAkD;AAClD;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,mCAAmC;IACnC,6DAA6D;IAC7D,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mCAAmC;IACnC,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,8CAA8C;AAC9C;IACI,gBAAgB;IAChB,sCAAsC;IACtC,iBAAiB;IACjB,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;IAC7C,eAAe;IACf,kBAAkB;AACtB;;AAEA,uCAAuC;AACvC;IACI,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,QAAQ;AACZ;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,SAAS;IACT,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,8CAA8C;AAClD;;AAEA;IACI,SAAS;IACT,SAAS;IACT,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA,uEAAuE;AACvE;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;IACtB,mCAAmC;AACvC;;AAEA;IACI,cAAc;AAClB;;AAEA,yDAAyD;AACzD;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,sCAAsC;IACtC,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,uDAAuD;AACvD;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;IACrB,aAAa;IACb,aAAa;IACb,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,gCAAgC;IAChC,gHAAgH;IAChH,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,cAAc;IACd,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,mCAAmC;AACvC;;AAEA;IACI,WAAW;AACf","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap');\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n:root {\n    --font_family: 'Lato', sans-serif;\n    --primary_font_size: 1rem;\n    --secondary_font_size: 0.938rem;\n    --ternary_font_size: 0.875rem;\n    --Primary_color: #38CAB3;\n    --secondary_color: #4F4F6D;\n    --ternary_color: #848498;\n    --box_shadow: rgba(170, 170, 170, 0.2) 0px 3px 6px 0px;\n    --text_shadow: 3px 0px 6px #818181;\n    --border_radius: 0.313rem;\n    --input_margin: 1.563rem;\n    --border: 0.063rem solid #D9D9D9;\n}\n\na {\n    text-decoration: none;\n}\n\nbody {\n    font-family: var(--font_family);\n}\n\nh1,\nh4,\nh5,\nh6,\nul {\n    margin-bottom: 0;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n    -moz-appearance: textfield;\n}\n\ninput[type=search]::-ms-clear {\n    display: none;\n    width: 0;\n    height: 0;\n}\n\ninput[type=search]::-ms-reveal {\n    display: none;\n    width: 0;\n    height: 0;\n}\n\ninput[type=\"search\"]::-webkit-search-decoration,\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-results-button,\ninput[type=\"search\"]::-webkit-search-results-decoration {\n    display: none;\n}\n\n/* Scroll Bar css */\n/* width */\n::-webkit-scrollbar {\n    width: 6px;\n    height: 5px;\n}\n\n::-webkit-scrollbar:vertical {\n    width: 0 !important;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 5px var(--secondary_color);\n    border-radius: 10px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n    background: var(--Primary_color);\n    border-radius: 5px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n    background: #0fc5aa;\n}\n\n\n.form-switch .form-check-input {\n    min-width: 3rem;\n    height: 20px;\n    border: 1px solid var(--Primary_color);\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='lightgreen'/%3e%3c/svg%3e\");\n}\n\n.form-switch .form-check-input:checked {\n    background-color: var(--Primary_color);\n}\n\n.form-switch .form-check-input:focus {\n    box-shadow: none;\n}\n\n.form_switch_wrapper {\n    position: relative;\n}\n\n.form_switch_wrapper span {\n    position: absolute;\n    top: 51%;\n    transform: translate(-50%, -50%);\n    font-size: 6px;\n    font-weight: bold;\n}\n\n/*=====css for validation message=========*/\n.srv-validation-message {\n    color: #e23a3a;\n    font-size: var(--ternary_font_size);\n    margin-top: 3px;\n}\n\n.swal2-confirm {\n    background-color: var(--Primary_color) !important;\n    border: unset !important;\n}\n\n.swal2-confirm:focus {\n    box-shadow: none !important;\n}\n\n.data_not_available_wrapper {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: var(--ternary_color);\n}\n\n.dashboard_data_not_available {\n    text-align: center;\n    margin-top: 10rem;\n    color: var(--ternary_color);\n}\n\n.refresh_icon {\n    color: var(--Primary_color);\n    cursor: pointer;\n}\n\n/* ======css for dashboard layout========== */\n.dashboard_wrapper {\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n}\n\n.side_nav_section {\n    width: 20%;\n    height: 100%;\n    background-color: #fff;\n    box-shadow: var(--box_shadow);\n    overflow-x: hidden;\n}\n\n.routes_view_section {\n    width: 80%;\n    height: 100%;\n}\n\n.side_nav_wrapper {\n    width: 100%;\n    height: 100%;\n}\n\n.logo {\n    height: 15%;\n    display: grid;\n    place-items: center;\n}\n\n.logo h1 {\n    color: var(--ternary_color);\n    font-weight: bold;\n}\n\n.nav_list_wrapper {\n    height: 79%;\n    overflow-y: auto;\n}\n\n.nav_list_wrapper::-webkit-scrollbar {\n    width: 0;\n}\n\n.logout_box_wrapper {\n    height: 6%;\n}\n\n.logout_box_wrapper .profile_box_wrapper {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    background-color: var(--Primary_color);\n    gap: 0.938rem;\n    padding-left: 0.625rem;\n    position: relative;\n    transition: 0.3s ease;\n}\n\n.logout_box_wrapper .box_main {\n    display: grid;\n    place-items: center;\n    transition: 0.2s ease-in-out;\n}\n\n.logout_box_wrapper .profile_box {\n    width: 1.875rem;\n    height: 1.875rem;\n    border-radius: 50%;\n    border: 0.063rem solid var(--Primary_color);\n    display: grid;\n    place-items: center;\n    color: var(--Primary_color);\n    cursor: pointer;\n}\n\n.logout_box_wrapper .profile {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n}\n\n.profile .profile_title {\n    color: #fff;\n    font-size: 0.813rem;\n}\n\n.logout_box_wrapper .profile_icon {\n    width: 1.375rem;\n    height: 1.375rem;\n    border-radius: 50%;\n    background-color: #fff;\n    display: grid;\n    place-items: center;\n}\n\n.profile_icon .svg-inline--fa {\n    color: var(--Primary_color);\n    font-size: 0.625rem;\n}\n\n.profile_box_wrapper .close_button {\n    position: absolute;\n    top: 50%;\n    left: 95%;\n    transform: translate(-50%, -50%);\n    width: 1.25rem;\n    height: 1.25rem;\n    border-radius: 50%;\n    background-color: #fff;\n    display: grid;\n    place-items: center;\n    cursor: pointer;\n}\n\n.profile_box_wrapper .close_button .svg-inline--fa {\n    font-size: 0.75rem;\n    color: var(--Primary_color);\n}\n\n.tab {\n    display: flex;\n    align-items: center;\n    padding: 0.375rem 0.188rem 0.375rem 1.125rem;\n    position: relative;\n    cursor: pointer;\n    margin-bottom: 0.625rem;\n    color: var(--ternary_color);\n    font-weight: bold;\n}\n\n.tab span,\n.dropdown_tab span {\n    font-size: var(--primary_font_size);\n}\n\n.tab .icon {\n    margin-right: 1rem;\n}\n\n.tab .icon .svg-inline--fa {\n    font-size: 1.125rem;\n}\n\n.dropdown_tab {\n    padding: 0.375rem 0.188rem 0.375rem 3.325rem;\n    cursor: pointer;\n    margin-bottom: 0.625rem;\n    color: var(--ternary_color);\n    font-weight: bold;\n    position: relative;\n}\n\n.dropdown_tab .sub_dropdown_tab {\n    margin-left: 15px;\n}\n\n.dropdown_tab ul li {\n    list-style-type: none;\n    color: var(--ternary_color);\n}\n\n.nav_list_wrapper .active .svg-inline--fa {\n    color: var(--Primary_color);\n}\n\n.nav_list_wrapper .active .tab span,\n.nav_list_wrapper .active .dropdown_tab span {\n    color: var(--secondary_color);\n}\n\n.tab .caret {\n    position: absolute;\n    top: 50%;\n    left: 92%;\n    transform: translate(-50%, -50%);\n}\n\n.tab .caret .svg-inline--fa {\n    transition: 0.3s ease;\n}\n\n.nav_list_wrapper .active .tab::after,\n.nav_list_wrapper .active .dropdown_tab::after,\n.nav_list_wrapper .tab_active::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 1.7%;\n    background-color: var(--Primary_color);\n    border-top-right-radius: 0.4rem;\n    border-bottom-right-radius: 0.4rem;\n}\n\n/*=============css for login and reset password page=========*/\n.login_wrapper {\n    width: 100vw;\n    height: 100vh;\n    display: grid;\n    place-items: center;\n}\n\n.login_wrapper .card_wrapper {\n    width: 90%;\n    height: 85%;\n    background-color: #fff;\n    overflow: hidden;\n    border-radius: var(--border_radius);\n    box-shadow: var(--box_shadow);\n}\n\n.login_wrapper .card_img {\n    width: 100%;\n    height: 100%;\n}\n\n.login_wrapper .card_img img {\n    width: 85%;\n    height: 90%;\n}\n\n.login_wrapper .form_wrapper {\n    height: 100% !important;\n    display: grid !important;\n    place-items: center;\n    overflow-y: auto;\n}\n\n.form {\n    align-items: center;\n    display: grid !important;\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n}\n\n.login_wrapper .form_wrapper::-webkit-scrollbar {\n    width: 0;\n}\n\n.login_wrapper .form_wrapper .form {\n    width: 70%;\n}\n\n.login_wrapper .title h1 {\n    color: var(--Primary_color);\n    font-weight: bold;\n    font-size: 30px;\n}\n\n.login_wrapper .title {\n    margin-bottom: 2.188rem;\n    text-align: center;\n}\n\n.login_wrapper .input_wrapper {\n    position: relative;\n    margin: var(--input_margin) 0 0 0;\n}\n\n.login_wrapper .input_wrapper input {\n    border: unset;\n    border-bottom: 1px solid var(--Primary_color);\n    border-radius: unset;\n}\n\n.input_wrapper input:focus {\n    box-shadow: none;\n}\n\n.login_wrapper .input_wrapper input::placeholder {\n    color: var(--Primary_color);\n}\n\n.login_wrapper .input_wrapper .svg-inline--fa {\n    position: absolute;\n    top: 50%;\n    left: 95%;\n    transform: translate(-50%, -50%);\n    color: var(--Primary_color);\n\n}\n\n.login_wrapper .reset {\n    text-align: right;\n    margin-top: 0.625rem;\n}\n\n.login_wrapper .reset a {\n    color: var(--Primary_color);\n}\n\n.login_wrapper .reset span {\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.login_wrapper .button {\n    width: 100%;\n    display: grid;\n    place-items: center;\n    background-color: var(--Primary_color);\n    color: #fff;\n    padding: 5px 10px;\n    border-radius: 1.25rem;\n    border: unset;\n    font-weight: bold;\n    margin-top: var(--input_margin);\n}\n\n.backto_login_wrapper {\n    margin-top: 15px;\n}\n\n.backto_login_wrapper a {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.backto_login_wrapper .back_icon {\n    /* width: 15px;\n    height: 15px; */\n    padding: 5px;\n    border-radius: 50%;\n    background-color: var(--Primary_color);\n    border: unset;\n    color: #fff;\n    display: grid;\n    place-items: center;\n}\n\n.backto_login_wrapper .back_icon .svg-inline--fa {\n    font-size: 12px;\n}\n\n.backto_login_wrapper h6 {\n    color: var(--Primary_color);\n    font-size: var(--ternary_font_size);\n    margin-left: 10px;\n}\n\n/* ========== Css for Loader========== */\n.conatiner_loader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    display: grid;\n    place-items: center;\n    /* background-color: #38CAB3; */\n}\n\n.laoder_wrapper {\n    position: absolute;\n    /* top: -2.188rem; */\n    transform: scale(1.5);\n}\n\n.loader {\n    height: 1.563rem;\n    width: 0.063rem;\n    position: absolute;\n    animation: rotate 3.5s linear infinite;\n}\n\n.loader .dot {\n    position: relative;\n    top: 1.875rem;\n    width: 0.438rem;\n    height: 0.438rem;\n    background-color: var(--Primary_color);\n    border-radius: 50%;\n}\n\n.loader_text {\n    position: absolute;\n    top: 65%;\n    font-size: var(--secondary_font_size);\n    font-weight: 600;\n    font-family: var(--font_family);\n    color: var(--Primary_color);\n}\n\n@keyframes rotate {\n    30% {\n        transform: rotate(220deg)\n    }\n\n    40% {\n        transform: rotate(450deg);\n        opacity: 1;\n    }\n\n    75% {\n        transform: rotate(720deg);\n        opacity: 1;\n    }\n\n    76% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 0;\n        transform: rotate(0deg);\n    }\n\n}\n\n.loader:nth-child(1) {\n    animation-delay: 0.15s;\n}\n\n.loader:nth-child(2) {\n    animation-delay: 0.3s;\n}\n\n.loader:nth-child(3) {\n    animation-delay: 0.45s;\n}\n\n.loader:nth-child(4) {\n    animation-delay: 0.6s;\n}\n\n.loader:nth-child(5) {\n    animation-delay: 0.75s;\n}\n\n.loader:nth-child(6) {\n    animation-delay: 0.9s;\n}\n\n/* ======== CSS for profile page =============== */\n.profile_wrapper {\n    width: 100%;\n    height: 100%;\n    display: grid;\n    place-items: center;\n}\n\n.profile_wrapper .profile_card {\n    width: 90%;\n    height: 80%;\n\n    border-radius: var(--border_radius);\n    box-shadow: var(--box_shadow);\n\n}\n\n.profile_wrapper .profile_card .profile_header {\n    background-color: var(--Primary_color);\n    padding: 0.625rem\n}\n\n.div_profile1 {\n    gap: 1.25rem\n}\n\n/* .profile_wrapper .profile_card .profile_body {\n    background-color: #fff;\n} */\n\n.profile_wrapper .profile_title .profile_icon {\n    color: #fff;\n    font-size: 0.813rem;\n    display: flex;\n\n}\n\n.profile_div {\n    display: flex;\n    gap: 20px;\n    justify-content: space-between;\n    color: #fff\n}\n\n.profile_wrapper .profile_icon {\n    width: 1.375rem;\n    height: 1.375rem;\n    border-radius: 50%;\n    background-color: #fff;\n    display: grid;\n    place-items: center;\n\n\n}\n\n.profile_wrapper .profile_icon .svg-inline--fa {\n    color: var(--Primary_color);\n    font-size: var(--primary_font_size);\n}\n\n.profile_body {\n    padding: 1.563rem;\n}\n\n.profile_wrapper .profile_body .form-control {\n\n    font-size: var(--ternary_font_size) !important;\n    font-weight: bold;\n    color: var(--secondary_color)\n}\n\n.edit_button {\n    margin-top: 2.5rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.profile_wrapper .div_profile2 .profile_icon {\n    cursor: pointer;\n}\n\n/*========css for top header============*/\n.top_header {\n    height: 7%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #fff;\n    box-shadow: rgba(197, 197, 197, 0.15) 0px 10px 10px -10px;\n    padding: 0.125rem 0.875rem;\n}\n\n.top_header .title {\n    position: relative;\n    padding-left: 0.625rem;\n    color: var(--secondary_color);\n    font-weight: bold;\n    font-size: var(--primary_font_size);\n}\n\n.top_header .title::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 0.188rem;\n    background-color: var(--Primary_color);\n}\n\n.top_header .search_wrapper {\n    position: relative;\n    box-shadow: rgba(164, 164, 164, 0.1) 0 0 1rem;\n    cursor: pointer;\n    overflow: hidden;\n}\n\n.top_header .search_wrapper input {\n    height: 2.313rem;\n    border: 0.063rem solid var(--Primary_color);\n    transition: 0.1s ease-in-out;\n}\n\n.top_header .search_wrapper input:focus {\n    box-shadow: none;\n}\n\n.top_header .search_wrapper .svg-inline--fa {\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    color: var(--Primary_color);\n}\n\n.top_header .search_wrapper input::placeholder {\n    margin-left: 20px;\n}\n\n/*===========css for pagination=============*/\n.paginationWrapper {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.paginationInputWrapper {\n    display: flex;\n    align-items: center;\n    position: relative;\n    width: 32%;\n    height: 30px;\n    border: 1px solid var(--Primary_color);\n    border-radius: 3px;\n}\n\n.paginationInputWrapper .form-control {\n    border: unset;\n    height: 100%;\n\n}\n\n\n.paginationWrapper .btn_pagination {\n    color: var(--Primary_color);\n    padding: 2px 8px;\n    border-radius: 3px;\n    border: 1px solid var(--Primary_color);\n    background-color: #fff;\n}\n\n.paginationWrapper .btn_pagination:disabled {\n    background-color: rgb(235, 235, 235);\n    cursor: not-allowed\n}\n\n.paginationInputWrapper .find_btn {\n    border: unset;\n    background-color: var(--Primary_color);\n    padding: 0px 10px;\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    color: #fff;\n\n}\n\n.paginationWrapper .paginationInputWrapper h6 {\n    color: var(--Primary_color);\n}\n\n\n.paginationInputWrapper .form-control:focus {\n    border-color: inherit;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n}\n\n.paginationInputWrapper .find_btn:hover {\n    background-color: var(--Primary_color);\n    color: #fff\n}\n\n/* old pagination */\n.pagination_wrapper .pagination li {\n    width: 21px;\n    height: 21px;\n    border-radius: 50%;\n    background-color: #fff;\n    color: var(--ternary_color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 12px;\n    font-weight: 600;\n    box-shadow: var(--box_shadow);\n}\n\n.pagination_wrapper .pagination li a {\n    font-size: 10px;\n}\n\n.pagination_wrapper .pagination .active {\n    color: #fff;\n    background-color: var(--Primary_color);\n}\n\n.pagination_wrapper .pagination .previous,\n.pagination_wrapper .pagination .next {\n    width: unset !important;\n    border-radius: 0 !important;\n    background-color: unset !important;\n    box-shadow: none;\n}\n\n.pagination_wrapper .pagination .previous a,\n.pagination_wrapper .pagination .next a {\n    color: var(--Primary_color) !important;\n    cursor: pointer;\n    font-weight: bold;\n}\n\n/*============css for table============*/\n.routes_view_section section {\n    height: 93%;\n    background-color: #F7F9FA;\n    padding: 0.875rem;\n    position: relative;\n}\n\n.routes_view_section .section_wrapper {\n    width: 100%;\n    height: 100%;\n    background-color: #fff;\n    box-shadow: rgba(164, 164, 164, 0.1) 0 0 1rem;\n    border-radius: var(--border_radius);\n    padding: 1% 1% 0 1%;\n}\n\n.section_header_wrapper {\n    width: 100%;\n    height: 8%;\n    /* background-color: #848498; */\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.survey_management_header {\n    height: 13%;\n    align-items: center;\n}\n\n.button_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.button,\n.filter_button {\n    border: 1px solid var(--Primary_color);\n    font-size: var(--ternary_font_size);\n    padding: 2px 15px;\n    color: var(--Primary_color);\n    background-color: #fff;\n    border-radius: 15px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: 0.3s ease-in;\n}\n\n.button:hover {\n    background-color: var(--Primary_color);\n    color: #fff;\n}\n\n.filter_button {\n    color: #fff;\n    background-color: var(--Primary_color);\n}\n\n.filter_button:hover {\n    background-color: #fff;\n    color: var(--Primary_color);\n}\n\n.table_wrapper {\n    width: 100%;\n    height: 92%;\n    overflow: auto;\n    position: relative;\n}\n\n.table_wrapper .table {\n    margin-bottom: 0;\n}\n\n.election_table,\n.survey_data_wrapper .table {\n    min-width: 1100px;\n}\n\n.organization_table {\n    min-width: 1600px;\n}\n\n.voter_table {\n    min-width: 1700px;\n}\n\n.survey_data_wrapper {\n    height: 87%;\n}\n\n.survey_trends_wrapper .table,\n.voter_list_wrapper .table {\n    min-width: 1300px;\n}\n\n.onField_input_table_wrapper {\n    height: 77%;\n}\n\n.onField_input_table_wrapper .table,\n.activity_table_wrapper .table {\n    min-width: 1350px;\n}\n\n.table_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #F7F9FA;\n    border: 1px solid #EDEDF5;\n    border-left: none;\n    border-right: none;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n\n.table_header .row,\n.table_data .row {\n    width: 100%;\n}\n\n.table_header h5 {\n    font-size: var(--ternary_font_size);\n    font-weight: 600;\n    color: var(--ternary_color);\n    text-align: center;\n}\n\n.table_data {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #EDEDF5;\n}\n\n.table_data h6 {\n    font-size: var(--ternary_font_size);\n    color: var(--ternary_color);\n    text-align: center;\n    text-transform: capitalize;\n}\n\n.survey_trends_wrapper .table_data h6 {\n    color: #fff;\n}\n\n.table_data .voterId h6 {\n    text-transform: unset;\n}\n\n.serial_number,\n.gender {\n    width: 8%;\n}\n\n.election_name,\n.booth_name,\n.full_name,\n.event_name,\n.description {\n    width: 20%;\n}\n\n.name,\n.election_type,\n.password,\n.designation,\n.alloted_member {\n    width: 15%;\n}\n\n.party,\n.city,\n.voterId {\n    width: 15%;\n}\n\n.election_year,\n.polling_name,\n.page_number,\n.mobile_number,\n.booth_name {\n    width: 13%;\n}\n\n.date,\n.userId,\n.survey_name,\n.points {\n    width: 13%;\n}\n\n.action,\n.gender,\n.election_action {\n    min-width: 10%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 3px;\n}\n\n.election_action {\n    width: 15%;\n}\n\n.row_action {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 3px;\n}\n\n.action .action_button,\n.election_action .action_button {\n    font-size: 12px;\n    padding: 1px 8px;\n    border-radius: 15px;\n    background-color: var(--Primary_color);\n    border: 1px solid var(--Primary_color);\n    color: #fff;\n}\n\n.action .svg-inline--fa,\n.row_action .svg-inline--fa,\n.election_action .svg-inline--fa {\n    color: var(--Primary_color);\n    cursor: pointer;\n}\n\n.password {\n    position: relative;\n}\n\n.password .svg-inline--fa {\n    position: absolute;\n    top: 50%;\n    right: 0%;\n    transform: translate(-50%, -50%);\n    padding: 0;\n    color: var(--ternary_color);\n    font-size: 14px;\n}\n\n.table_data .password h5 {\n    font-size: 24px;\n    margin-top: -15px;\n    color: var(--ternary_color);\n}\n\n.password h6 {\n    text-align: left;\n\n}\n\n\n.vote {\n    width: 25%;\n    text-align: center;\n    overflow: hidden;\n}\n\n/*==========css for modal===========*/\n.modal_wrapper {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #bababa4a;\n    display: grid;\n    place-items: center;\n    z-index: 1;\n}\n\n.form_wrapper_main {\n    width: 100%;\n    height: 100%;\n    background-color: #F7F9FA;\n    display: grid;\n    place-items: center;\n}\n\n.modal_wrapper .card_wrapper,\n.form_wrapper_main .card_wrapper {\n    width: 60%;\n    max-height: 95%;\n    overflow-y: auto;\n    background-color: #fff;\n    border-radius: var(--border_radius);\n    border: var(--border);\n    box-shadow: var(--box_shadow);\n}\n\n.form_wrapper_main .card_wrapper {\n    width: 90%;\n}\n\n.modal_wrapper .card_header,\n.form_wrapper_main .card_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 7px 15px;\n    border-bottom: var(--border);\n    position: sticky;\n    top: 0;\n    background-color: #fff;\n}\n\n.modal_wrapper .card_header .title,\n.form_wrapper_main .card_header .title {\n    position: relative;\n    padding-left: 10px;\n}\n\n.modal_wrapper .card_header .title h5,\n.form_wrapper_main .card_header .title h5 {\n    font-size: var(--secondary_font_size);\n    color: var(--secondary_color);\n    font-weight: 600;\n}\n\n.modal_wrapper .card_header .title::after,\n.form_wrapper_main .card_header .title::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 3px;\n    height: 100%;\n    background-color: var(--Primary_color);\n}\n\n.modal_wrapper .card_header .close_button,\n.form_wrapper_main .card_header .close_button {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    border: 1px solid var(--Primary_color);\n    display: grid;\n    place-items: center;\n    color: var(--Primary_color);\n    cursor: pointer;\n}\n\n.modal_wrapper .card_body,\n.form_wrapper_main .card_body {\n    padding: 15px;\n}\n\n.input_box_wrapper {\n    margin-bottom: 10px;\n}\n\n.input_box_wrapper label {\n    font-size: var(--ternary_font_size);\n    color: var(--secondary_color);\n    font-weight: 600;\n    margin-bottom: 5px;\n}\n\n.input_box_wrapper input,\n.input_box_wrapper select,\n.input_box_wrapper textarea,\n.react-datepicker-wrapper input {\n    border: var(--border);\n    box-shadow: var(--box_shadow);\n    line-height: 1.4;\n    font-size: var(--ternary_font_size);\n    color: var(--ternary_color) !important;\n}\n\n.multiSelectContainer {\n    border: unset;\n}\n\n.multiSelectContainer .searchWrapper {\n    position: relative;\n    min-height: 32.93px;\n    padding: 0;\n    overflow: hidden;\n    box-shadow: var(--box_shadow);\n}\n\n.multiSelectContainer .searchWrapper input {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    padding: 0.375rem 0.75rem;\n    border-radius: var(--border_radius);\n    margin-top: 0;\n}\n\n.multiSelectContainer .searchWrapper .svg-inline--fa {\n    font-size: 14px;\n}\n\n.multiSelectContainer .searchWrapper input:focus {\n    border: unset;\n}\n\n.icon_down_dir {\n    right: 12px;\n}\n\n.icon_down_dir:before {\n    display: none;\n}\n\n.chip img {\n    display: none;\n}\n\n.input_box_wrapper input::placeholder,\n.input_box_wrapper textarea::placeholder,\n.react-datepicker-wrapper input::placeholder {\n    color: var(--ternary_color);\n}\n\n.input_box_wrapper input:focus,\n.input_box_wrapper select:focus,\n.input_box_wrapper textarea:focus,\n.react-datepicker-wrapper input:focus {\n    box-shadow: none;\n    border: var(--border);\n}\n\n.react-datepicker-wrapper input {\n    width: 100%;\n    border-radius: var(--border_radius);\n    padding: 0.375rem 0.75rem;\n}\n\n.react-datepicker-ignore-onclickoutside:focus {\n    outline: none;\n}\n\n.input_box_wrapper .party_select_box,\n.input_box_wrapper .designation_select_box {\n    text-transform: capitalize;\n}\n\n.modal_wrapper .submit_button_wrapper,\n.form_wrapper_main .submit_button_wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.modal_wrapper .submit_button_wrapper .filter_button,\n.form_wrapper_main .submit_button_wrapper .filter_button {\n    padding: 3px 25px;\n    font-weight: 600;\n    margin-top: 10px;\n}\n\n.form-select_data {\n    width: 0;\n    float: right;\n}\n\n.button_wrapper select {\n    line-height: 1.4;\n    font-size: var(--ternary_font_size);\n    border: 1px solid var(--Primary_color);\n    color: var(--Primary_color);\n    border-radius: 20px;\n    padding: 3px 30px 3px 10px;\n}\n\n.button_wrapper select:focus {\n    box-shadow: none;\n}\n\n.import_data_wrapper {\n    width: 60%;\n    margin: auto;\n}\n\n.import_data_wrapper label {\n    width: 100%;\n    border: 1px solid var(--Primary_color);\n    padding: 3% 2%;\n    box-shadow: var(--box_shadow);\n    border-radius: var(--border_radius);\n    text-align: center;\n    color: var(--Primary_color);\n    overflow: hidden;\n    margin-bottom: 15px;\n    cursor: pointer;\n}\n\n.import_data_wrapper .svg-inline--fa {\n    font-size: 24px;\n    margin-bottom: 15px;\n}\n\n.import_data_wrapper span {\n    color: var(--ternary_color);\n}\n\n/* ========== Designation CSS ============== */\n\n\n.designation_wrapper {\n    width: 100%;\n    height: 100%;\n    background-color: #F7F9FA;\n    display: grid;\n    place-items: center;\n}\n\n\n.designation_wrapper .designation_card {\n    width: 90%;\n    height: 90%;\n    overflow-y: auto;\n    background-color: #fff;\n    border-radius: var(--border_radius);\n    border: var(--border);\n    box-shadow: var(--box_shadow);\n\n}\n\n.designation_wrapper .card_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 7px 15px;\n    border-bottom: var(--border);\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background-color: #fff;\n}\n\n.designation_wrapper .card_header .title {\n    position: relative;\n    padding-left: 10px;\n}\n\n.designation_wrapper .card_header .title h5 {\n    font-size: var(--ternary_font_size);\n    color: var(--secondary_color);\n    font-weight: 600;\n}\n\n.designation_wrapper .designation_card .card_header .close_button {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    border: 1px solid var(--Primary_color);\n    display: grid;\n    place-items: center;\n    color: var(--Primary_color);\n    cursor: pointer;\n}\n\n.designation_wrapper .card_body {\n    padding: 1.563rem;\n}\n\n.designation_wrapper .designation_tab_heading h6 {\n    font-size: var(--secondary_font_size);\n    color: var(--Primary_color);\n    font-weight: bold;\n\n}\n\n.designation_wrapper .check_box_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.check_box_wrapper label {\n    font-size: var(--ternary_font_size);\n    color: var(--secondary_color);\n    font-weight: 600;\n    margin-bottom: 5px;\n}\n\n.designation_card .card_header .close_button {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    border: 1px solid var(--Primary_color);\n    display: grid;\n    place-items: center;\n    color: var(--Primary_color);\n    cursor: pointer;\n}\n\n.action_designation .svg-inline--fa {\n    color: var(--Primary_color);\n    cursor: pointer;\n}\n\n.booth_access_wrapper {\n    position: relative;\n}\n\n.booth_access_wrapper .add_access_button {\n    position: absolute;\n    top: 50%;\n    right: 5%;\n    transform: translate(-50%, -20%);\n    border: var(--border);\n    box-shadow: var(--box_shadow);\n    color: var(--ternary_color) !important;\n    padding: 3px 10px;\n    border-radius: var(--border_radius);\n    background-color: var(--Primary_color);\n    color: #fff !important;\n}\n\n.booth_access_wrapper .trash_button {\n    position: absolute;\n    top: 40%;\n    right: 15%;\n    transform: translate(-50%, -50%);\n    cursor: pointer;\n    color: #e23a3a;\n}\n\n.gender_input_wrapper {\n    display: flex;\n    gap: 15px;\n}\n\n/*=====survey management css========*/\n.vote .party_wrapper {\n    width: 100%;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    gap: 10px;\n}\n\n.gender_input input {\n    color: var(--Primary_color);\n    margin-top: 0;\n}\n\n.gender_input label {\n    font-size: var(--ternary_font_size);\n    color: var(--ternary_color);\n    margin-left: 8px;\n    font-weight: normal;\n    margin-bottom: 0;\n}\n\n.gender_input {\n    display: flex;\n    align-items: center;\n}\n\n.vote .party_wrapper .party_input {\n    width: calc(100% / 3);\n}\n\n.vote .party_wrapper input {\n    margin-top: 0.35rem;\n    border: 1px solid var(--Primary_color);\n}\n\n.vote .party_wrapper .form-check-input:checked {\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='lightgreen'/%3e%3c/svg%3e\");\n    background-color: unset !important;\n    box-shadow: unset;\n}\n\n.vote .party_wrapper label {\n    margin-left: 5px;\n    color: var(--ternary_color);\n    font-size: var(--ternary_font_size);\n}\n\n.survey_data_wrapper .link a {\n    border-bottom: 1px solid var(--ternary_color);\n    cursor: pointer;\n}\n\n.survey_card_wrapper,\n.data_analysis_card_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.survey_card_wrapper .survey_card,\n.data_analysis_card_wrapper .survey_card {\n    min-width: 150px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 15px;\n    padding: 5px 10px;\n    border-radius: var(--border_radius);\n    background-image: linear-gradient(to right, #40DA9C, #3CC0AD);\n}\n\n.data_analysis_card_wrapper {\n    margin: 15px 0;\n    gap: 20px;\n}\n\n.data_analysis_card_wrapper .survey_card {\n    min-width: 25%;\n}\n\n.survey_card_wrapper .survey_card:nth-child(2),\n.data_analysis_card_wrapper .survey_card:nth-child(2) {\n    background-image: linear-gradient(to right, #FFC944, #FF9F50);\n}\n\n.survey_card_wrapper .survey_card h6,\n.data_analysis_card_wrapper .survey_card h6 {\n    font-size: 12px;\n    color: #fff;\n    text-shadow: var(--text_shadow);\n}\n\n.data_analysis_card_wrapper .survey_card h6 {\n    font-size: var(--primary_font_size);\n    font-weight: 600;\n}\n\n.survey_card .icon_wrapper {\n    text-align: center;\n}\n\n.survey_card .icon_wrapper .svg-inline--fa {\n    color: var(--Primary_color);\n    color: #fff;\n    text-shadow: var(--text_shadow);\n}\n\n.data_analysis_card_wrapper .survey_card .icon_wrapper .svg-inline--fa {\n    font-size: 24px;\n    margin-bottom: 7px;\n}\n\n.input_box_wrapper .checkbox_wrapper {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 20px;\n}\n\n.checkbox_wrapper .form-check-input {\n    margin-top: 0;\n    border: 1px solid var(--Primary_color);\n}\n\n.checkbox_wrapper h6 {\n    font-size: var(--ternary_font_size);\n    color: var(--ternary_color);\n}\n\n.aid_card_wrapper {\n    width: 80% !important;\n}\n\n/*==========css for Data Analysis===========*/\n.survey_analysis_tab_wrapper {\n    display: flex;\n    align-items: center;\n}\n\n.survey_analysis_tab_wrapper .tab {\n    min-width: 10%;\n    padding: 5px 10px;\n    border: 1px solid var(--Primary_color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.survey_analysis_tab_wrapper .tab h5 {\n    font-size: var(--primary_font_size);\n    font-weight: 600;\n    color: var(--Primary_color);\n}\n\n.survey_analysis_tab_wrapper .active {\n    background-color: var(--Primary_color);\n}\n\n.survey_analysis_tab_wrapper .active h5 {\n    color: #fff;\n}\n\n.survey_analysis_graph_wrapper {\n    width: 100%;\n    height: 60vh;\n    overflow-x: auto;\n}\n\n.survey_analysis_graph_wrapper .graph_main {\n    width: 100%;\n    overflow-x: auto;\n}\n\n.survey_analysis_graph_wrapper::-webkit-scrollbar {\n    width: 0 !important;\n}\n\n.survey_analysis_graph_wrapper canvas {\n    max-height: 350px;\n}\n\n/*==========css for Voting Day Tab===============*/\n.counter_card_wrapper {\n    width: 100%;\n    height: 15%;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    padding: 0 0 15px 0;\n}\n\n.counter_card_wrapper .counter_card {\n    width: calc(100% / 6);\n    text-align: center;\n    padding: 5px;\n    border-radius: var(--border_radius);\n    background-image: linear-gradient(to right, #21D1D6, #4994E2);\n    color: #fff;\n}\n\n.counter_card_wrapper .counter_card h5 {\n    font-size: var(--secondary_font_size);\n    margin-bottom: 5px;\n    font-weight: 600;\n    text-shadow: var(--text_shadow);\n}\n\n.counter_card_wrapper .counter_card h6 {\n    font-size: var(--ternary_font_size);\n    font-weight: 600;\n    text-shadow: var(--text_shadow);\n}\n\n.counter_card_wrapper .counter_card:nth-child(2) {\n    background-image: linear-gradient(to right, #3FD899, #3CBEAE);\n}\n\n.counter_card_wrapper .counter_card:nth-child(3) {\n    background-image: linear-gradient(to right, #C087F7, #9342D0);\n}\n\n.counter_card_wrapper .counter_card:nth-child(4) {\n    background-image: linear-gradient(to right, #F06A7C, #F95E91);\n}\n\n.counter_card_wrapper .counter_card:nth-child(5) {\n    background-image: linear-gradient(to right, #FFCB43, #FF9852);\n}\n\n.msi_panel_wrapper {\n    height: 100%;\n}\n\n.msi_panel_wrapper .col-lg-6 {\n    height: 50%;\n}\n\n.msi_panel_wrapper .col-lg-6:nth-child(2) .msi_panel_card_wrapper {\n    overflow-y: auto;\n}\n\n.msi_panel_wrapper .col-lg-6:nth-child(2) .msi_panel_card_wrapper::-webkit-scrollbar {\n    height: 0;\n}\n\n.msi_panel_card_wrapper,\n.dashboard_graph_card_wrapper {\n    width: 100%;\n    height: 100%;\n    background-color: #fff;\n    border-radius: var(--border_radius);\n    padding: 8px;\n}\n\n.msi_panel_card_wrapper .booth_card_wrapper {\n    width: 100%;\n    display: flex;\n    gap: 15px;\n}\n\n.booth_card_wrapper .booth_card {\n    width: calc(100% / 2);\n}\n\n.booth_card_wrapper .booth_card .title h5 {\n    font-size: var(--ternary_font_size);\n    color: #FFC446;\n    font-weight: 600;\n    text-shadow: 3px 0px 6px #d3d2d2;\n    text-align: left;\n}\n\n.booth_card_wrapper .booth_table {\n    text-align: center;\n    margin-top: 10px;\n}\n\n.booth_table .header,\n.booth_table .data {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    padding: 8px 3px;\n}\n\n.booth_table .data {\n    border-bottom: 1.2px solid rgb(234, 233, 233);\n}\n\n.booth_table .header h6 {\n    color: #fff !important;\n    text-shadow: var(--text_shadow);\n}\n\n.booth_card_wrapper .booth_table h6 {\n    font-size: 13px;\n    color: var(--ternary_color);\n}\n\n.booth_table .data .column a {\n    border-bottom: 1px solid grey;\n    cursor: pointer;\n}\n\n.booth_table .column {\n    width: calc(100% / 3);\n}\n\n.booth_card_wrapper .booth_card:nth-child(1) .header {\n    background-image: linear-gradient(to right, #FFC944, #FFA150);\n}\n\n.booth_card_wrapper .booth_card:nth-child(2) .header {\n    background-image: linear-gradient(to right, #40DA9C, #3CC3AA);\n}\n\n.booth_card_wrapper .booth_card:nth-child(2) .title h5 {\n    color: var(--Primary_color);\n}\n\n/* =============BenificialVote ==============*/\n.beneficial_voters_count {\n    min-width: 230px;\n    border: 1px solid var(--Primary_color);\n    padding: 3px 15px;\n    color: var(--Primary_color);\n    background-color: #fff;\n    border-radius: 15px;\n    line-height: 1.4;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    font-size: var(--ternary_font_size);\n}\n\n.beneficial_voters_count h6 {\n    font-size: var(--ternary_font_size);\n}\n\n.msi_panel_card_wrapper .title h5,\n.dashboard_graph_card_wrapper .title h5 {\n    text-align: center;\n    font-size: var(--secondary_font_size);\n    font-weight: 600;\n    color: var(--secondary_color);\n}\n\n.booth_report_graph_wrapper {\n    width: 100%;\n    height: 100%;\n    overflow-x: auto;\n}\n\n.booth_report_graph_wrapper .booth_report_graph {\n    width: auto;\n    overflow-x: auto;\n}\n\n.booth_report_graph_wrapper::-webkit-scrollbar {\n    width: 0 !important;\n}\n\n.booth_report_graph_wrapper canvas {\n    max-height: 210px;\n}\n\n.final_report_graph_wrapper {\n    width: 100%;\n    height: 100%;\n}\n\n.final_report_graph {\n    height: 100%;\n    overflow-y: auto;\n    display: grid;\n    place-items: center;\n}\n\n.final_report_graph canvas {\n    width: 180px !important;\n    height: 180px !important;\n}\n\n.final_report_label_wrapper {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    gap: 10px;\n}\n\n.final_report_label_wrapper .label_wrapper,\n.voting_area_label_wrapper .voting_area_label {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.voting_area_label_wrapper .voting_area_label {\n    margin-bottom: 10px;\n}\n\n.final_report_label_wrapper .label_wrapper h6,\n.voting_area_label_wrapper .voting_area_label h6 {\n    color: var(--ternary_color);\n    font-size: 12px;\n}\n\n.final_report_label_wrapper .label_wrapper .label_color_box,\n.voting_area_label_wrapper .label_color_box {\n    width: 40px;\n    height: 12px;\n}\n\n.final_report_label_wrapper .label_wrapper:nth-child(1) .label_color_box {\n    background-color: #3BCD90;\n}\n\n.final_report_label_wrapper .label_wrapper:nth-child(2) .label_color_box {\n    background-color: #25D2DC;\n}\n\n.final_report_label_wrapper .label_wrapper:nth-child(3) .label_color_box {\n    background-color: #FA6D83;\n}\n\n.hyperlink a {\n    border-bottom: 1px solid var(--ternary_color);\n    cursor: pointer;\n    margin-bottom: 8px;\n}\n\n/*======css for voting area graph=====*/\n.voting_area_label_wrapper .voting_area_label:nth-child(1) .label_color_box {\n    background-color: var(--Primary_color);\n}\n\n.voting_area_label_wrapper .voting_area_label:nth-child(2) .label_color_box {\n    background-color: #6DE8D4;\n}\n\n.voting_area_label_wrapper .voting_area_label:nth-child(3) .label_color_box {\n    background-color: #FF7D7D;\n}\n\n.voting_area_graph_wrapper {\n    width: 100%;\n    height: 100%;\n    /* overflow-y: auto; */\n}\n\n.voting_area_graph_wrapper::-webkit-scrollbar {\n    width: 0;\n}\n\n/*=================================*/\n.voting_area_graph_wrapper {\n    position: relative;\n    height: 100%;\n}\n\n.voting_area_graph_wrapper .svg_wrapper {\n    position: absolute;\n    width: 100px;\n    height: 80px;\n    overflow: hidden;\n}\n\n.voting_area_graph_wrapper .svg_wrapper svg {\n    width: 100%;\n    height: 100%;\n}\n\n.voting_area_graph_wrapper .svg_wrapper svg path {\n    stroke: grey;\n    stroke-width: 20;\n}\n\n.voting_area_graph_wrapper .svg_wrapper h6 {\n    position: absolute;\n    top: 50%;\n    left: 45%;\n    transform: translate(-50%, -50%);\n    font-size: 12px;\n    text-align: center;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(1) {\n    top: 30%;\n    left: 7%;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(2) {\n    top: -10%;\n    left: 30%;\n    width: 130px;\n    height: 110px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(3) {\n    top: 66.3%;\n    right: 8.5%;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(4) {\n    top: 70%;\n    left: -19%;\n    width: 150px;\n    height: 130px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(5) {\n    top: 97%;\n    left: 15%;\n    width: 80px;\n    height: 75px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(5) h6 {\n    font-size: 11px;\n    transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(6) {\n    top: 86%;\n    left: 30%;\n    width: 80px;\n    height: 50px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(7) {\n    top: 143.5%;\n    left: -11.4%;\n    width: 129px;\n    height: 130px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(8) {\n    top: 180%;\n    left: 7%;\n    width: 190px;\n    height: 90px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(8) h6 {\n    top: 40%;\n    transform: translate(-20%, -50%) rotate(45deg);\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(9) {\n    top: 113%;\n    left: 40%;\n    width: 104px;\n    height: 100px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(10) {\n    top: 95%;\n    right: 0%;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(10) h6 {\n    top: 70%;\n    left: 55%;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(11) {\n    top: 120%;\n    left: -20%;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(12) {\n    top: 180%;\n    right: 23%;\n    width: 107px;\n    height: 90px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(12) h6 {\n    transform: translate(-50%, -50%) rotate(-45deg);\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(13) {\n    top: 182%;\n    right: 5%;\n    width: 80px;\n    height: 60px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(14) {\n    top: 285%;\n    left: -7%;\n    width: 120px;\n    height: 95px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(14) h6 {\n    top: 35%;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(15) {\n    top: 264.5%;\n    left: 25.9%;\n    width: 115px;\n    height: 88px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(15) h6 {\n    top: 40%;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(16) {\n    top: 225%;\n    right: 13.5%;\n    width: 90px;\n    height: 78px;\n}\n\n.voting_area_graph_wrapper .svg_wrapper:nth-child(16) h6 {\n    left: 55%;\n}\n\n/*==================css for Activity management tab===================*/\n.event_button_wrapper {\n    height: 100%;\n    position: relative;\n}\n\n.event_button_wrapper button {\n    position: absolute;\n    bottom: 13px;\n    border: var(--border);\n    padding: 2px 8px;\n    background-color: #fff;\n    border-radius: var(--border_radius);\n}\n\n.event_button_wrapper button .trash {\n    color: #e23a3a;\n}\n\n/*=================css for Download Template============*/\n.download_template_wrapper {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 40px;\n}\n\n.download_template_wrapper .card_wrapper {\n    position: relative;\n    min-width: 300px;\n    text-align: center;\n    border-radius: var(--border_radius);\n    background-color: var(--Primary_color);\n    padding: 1% 2%;\n    overflow: hidden;\n    cursor: pointer;\n}\n\n.download_template_wrapper .card_wrapper::before {\n    position: absolute;\n    content: \"\";\n    left: -10%;\n    bottom: -6%;\n    width: 30%;\n    height: 40%;\n    background-color: #fff;\n    transform: rotate(45deg);\n}\n\n.download_template_wrapper .card_wrapper h6 {\n    color: #fff;\n    text-shadow: var(--text_shadow);\n    font-size: var(--ternary_font_size);\n    font-weight: 600;\n}\n\n.download_template_wrapper .card_wrapper .svg-inline--fa {\n    color: #fff;\n    box-shadow: var(--box_shadow);\n}\n\n.download_template_wrapper .card_wrapper:nth-child(1) h6,\n.download_template_wrapper .card_wrapper:nth-child(2) h6 {\n    margin: 5px 0;\n}\n\n.download_template_wrapper .card_wrapper:nth-child(1) {\n    background-image: linear-gradient(to right, #40DA9C, #3CC0AD);\n}\n\n.download_template_wrapper .card_wrapper:nth-child(2) {\n    background-image: linear-gradient(to right, #FFC944, #FF9F50);\n}\n\n.download_template_wrapper .card_wrapper .download_icon {\n    position: absolute;\n    left: 3%;\n    bottom: 7%;\n    box-shadow: unset;\n}\n\n.download_template_wrapper .card_wrapper:nth-child(1) .download_icon {\n    color: var(--Primary_color);\n}\n\n.download_template_wrapper .card_wrapper:nth-child(2) .download_icon {\n    color: #FFC944;\n}\n\n/*==================css for Dashboard=================*/\n.current_progress_wrapper {\n    width: 100%;\n    height: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.dashboard_graph_wrapper {\n    width: 100%;\n    height: 100%;\n    overflow-x: auto;\n}\n\n.dashboard_graph_wrapper canvas {\n    max-height: 500px !important;\n}\n\n.immediate_focus_graph canvas {\n    cursor: pointer;\n}\n\n.dashboard_card_wrapper {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 5.5%;\n}\n\n.dashboard_card_wrapper .card_wrapper {\n    position: relative;\n    box-shadow: var(--box_shadow);\n    width: calc(100% / 5);\n    height: 150px;\n    padding: 10px;\n    border-top-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n}\n\n.dashboard_card_wrapper .card_wrapper .inner_card {\n    margin: auto;\n    width: 95%;\n    height: 95%;\n    display: grid;\n    place-items: center;\n    text-align: center;\n    border-top-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 20px 40px -12px inset, rgba(179, 179, 179, 0.3) 0px 18px 36px -18px inset;\n    padding: 2%;\n}\n\n.dashboard_card_wrapper .card_wrapper .count {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    min-width: 70%;\n    height: 20%;\n    background-color: #fff;\n    display: grid;\n    place-items: center;\n}\n\n.dashboard_card_wrapper .card_wrapper .count h6 {\n    color: var(--ternary_color);\n    font-weight: 600;\n    font-size: 13px;\n    letter-spacing: 1px;\n}\n\n.dashboard_card_wrapper .card_wrapper .inner_card .svg-inline--fa {\n    font-size: 22px;\n    color: #fff;\n    box-shadow: var(--box_shadow);\n    margin-bottom: 8px;\n}\n\n.dashboard_card_wrapper .card_wrapper .inner_card h6 {\n    font-size: 11px;\n    font-weight: 600;\n    color: #fff;\n    text-shadow: var(--text_shadow);\n}\n\n.dashboard_card_wrapper .card_wrapper:nth-child(1) .inner_card {\n    background-image: linear-gradient(to bottom, #20D9DB, #5487E7);\n}\n\n.dashboard_card_wrapper .card_wrapper:nth-child(2) .inner_card {\n    background-image: linear-gradient(to bottom, #F85A94, #FA7081);\n}\n\n.dashboard_card_wrapper .card_wrapper:nth-child(3) .inner_card {\n    background-image: linear-gradient(to bottom, #40DC9A, #3CB9B2);\n}\n\n.dashboard_card_wrapper .card_wrapper:nth-child(4) .inner_card {\n    background-image: linear-gradient(to bottom, #FFD042, #FF8A56);\n}\n\n.dashboard_card_wrapper .card_wrapper:nth-child(5) .inner_card {\n    background-image: linear-gradient(to bottom, #C48DFA, #8831C6);\n}\n\n.dashboard_card_wrapper .card_wrapper:nth-child(1) .count {\n    border-bottom: 1.5px solid #29CADD;\n}\n\n.dashboard_card_wrapper .card_wrapper:nth-child(2) .count {\n    border-bottom: 1.5px solid #FA6A86;\n}\n\n.dashboard_card_wrapper .card_wrapper:nth-child(3) .count {\n    border-bottom: 1.5px solid #3FD69E;\n}\n\n.dashboard_card_wrapper .card_wrapper:nth-child(4) .count {\n    border-bottom: 1.5px solid #FFC545;\n}\n\n.dashboard_card_wrapper .card_wrapper:nth-child(5) .count {\n    border-bottom: 1.5px solid #B475EC;\n}\n\n\n.current_progress_wrapper .dashboard_graph_card_wrapper {\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    box-shadow: var(--box_shadow);\n    border-radius: var(--border_radius);\n}\n\n.current_progress_wrapper .main_card_column {\n    height: 70%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
